import { z } from 'zod';
import { ancestorsSchema } from '@/types/tree';

export const folderSchema = z.object({
  createdAt: z.string(),
  createdBy: z.object({
    id: z.string(),
    name: z.string(),
  }),
  description: z.string(),
  destinations: z.string().array().optional(),
  id: z.string(),
  locked: z.boolean(),
  name: z.string(),
  nodeId: z.string(),
  parentFolderId: z.string().nullable(),
  slug: z.string(),
  tenantId: z.string(),
  updatedAt: z.string(),
  trashedAt: z.string().nullable().optional(),
  ancestors: ancestorsSchema.nullable().optional(),
});

export type Folder = z.infer<typeof folderSchema>;

const CreateFolderParams = folderSchema.pick({ name: true, description: true, parentFolderId: true }).partial({
  description: true,
  parentFolderId: true,
});

export type CreateFolderParams = z.infer<typeof CreateFolderParams>;
export type CreateFolderFn = (params: CreateFolderParams) => Promise<Folder>;

const DeleteFolderParams = folderSchema.pick({ id: true });

export type DeleteFolderParams = z.infer<typeof DeleteFolderParams>;
export type DeleteFolderFn = (params: DeleteFolderParams) => Promise<Folder>;

const RenameFolderParams = folderSchema.pick({ name: true, description: true, slug: true }).partial({
  name: true,
  description: true,
  slug: true,
});

export type RenameFolderParams = z.infer<typeof RenameFolderParams>;
